// Import statements
import React from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Component definition
const WeServe = () => {
  const items = [
    { img:'/images/01_icon.jpg', link: '/coming-soon', title: 'Manufacturing', description: 'We provide tailored financial and compliance services to manufacturing companies, helping them optimize operations, manage costs, and ensure regulatory compliance.' },
    { img:'/images/02_icon.jpg', link: '/coming-soon', title: 'Engineering & Consultancy', description: 'Our expertise supports engineering and consultancy firms with financial planning, project management, and regulatory compliance, enabling them to deliver exceptional results.' },
    { img:'/images/03_icon.jpg', link: '/coming-soon', title: 'Textile', description: 'We assist textile businesses in improving financial management, streamlining operations, and maintaining compliance with industry regulations.' },
    { img:'/images/04_icon.jpg', link: '/coming-soon', title: 'Real Estate & Infrastructure', description: 'We offer specialized services to real estate and infrastructure developers, including financial structuring, tax planning, and compliance, ensuring successful project execution and investment management.' },
  ];

  const settings = {
    dots: false, // Enable navigation dots
    infinite: true, // Enable infinite loop
    speed: 500,
    slidesToShow: 3, // Show 3 slides at a time
    slidesToScroll: 1, // Scroll one slide at a time
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024, // Adjust for tablets
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600, // Adjust for mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
};

  return (
    <div className='we_serve mb-5'>
        <div className='container'>
            <div className='top_content_wrap text-center pt-5'>
                <h2>INDUSTRIES WE SERVE</h2>
                <p>We are dedicated to transforming businesses for sustainable growth, guiding our clients towards a prosperous
                    future. Our diverse team of experts provides comprehensive support from strategy development to execution,
                    helping companies overcome their most complex challenges and achieve their full potential.</p>
            </div>
            <div className='row'>
                <Slider {...settings}>
                    {items.map((item, index) => (
                        <div className='col-md-3'>
                            <div key={index} className="inr_box_text text-center">
                                <div className='box-icon-text'>
                                    <img src={item.img} alt={item.title} />
                                    <h5>{item.title}</h5>
                                </div>
                                <p>{item.description}</p>
                                <Link to={item.link} className="rounded-pill btn solid_btn">
                                Read more <i className="fas fa-chevron-right"></i>
                              </Link>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    </div>
  );
};

// Export the component
export default WeServe;
